import { Typography, Button, Row, Col }  from 'antd'
import Breakpoint from '../../enums/breakpoint.enum.js'
import LatestPosts from '../latestPosts/latestPosts.component.js'
import useWidth from '../../hooks/useWidth.hook.js'


const { Text, Paragraph } = Typography

export const SleepApneaTestConfirm = () => {
  const width = useWidth()

  const instructions = [{
    sections: [
      {
      title: 'Receive the WatchPat One Device',
      description: <>The WatchPat One is an FDA-approved sleep device with a wrist sensor, pulse oximeter, and chest sensor. It collects data from the wrist, finger, and neck.</>
    }, 
  ]}, 
  {
    sections: [{
      title: 'Wear WatchPat One for one night',
      description: <>The device is super easy and comfortable to wear. It'll gather data on seven key sleep apnea metrics, which will be sent to Instalab for analysis.</>
    }]
  }, 
  {
    sections: [{
      title: 'Get Test Results',
      description: <>An Instalab physician will review your sleep data and provide a detailed personal sleep report with recommendations.</>
    }]
  }]

  return (
    <div className="prescription-approval">


      {instructions?.length > 0 && (
        <div className="instruction-list">
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>
      )}

      <Button
        className="question-btn"
        onClick={() => window.FrontChat("show")}
      >
        I have a question?
      </Button>

      <LatestPosts />
    </div>
  )
}

